import { render, staticRenderFns } from "./InspectionResultModal.vue?vue&type=template&id=c6650700"
import script from "./InspectionResultModal.vue?vue&type=script&lang=js"
export * from "./InspectionResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports